'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { RunningProductItem } from './running-product-item'

type Props = {
  title: string
  data: {
    thumbnail: string
    productIds: string[]
  }[]
}

export const RunningHighlightProduct: React.FC<Props> = ({ title, data }) => {
  return (
    <CollectionContainer>
      <div className='mb-4 flex items-center justify-between'>
        <h3 className='text-lg font-medium uppercase text-neutral-900 md:text-2xl'>
          {title}
        </h3>
      </div>

      <div>
        <Carousel
          opts={{
            align: 'start',
            loop: false,
          }}
          className='w-full'
        >
          <CarouselContent className='-ml-4'>
            {data.map((item, index) => (
              <CarouselItem
                key={index}
                className='basis-[80%] pl-4 md:basis-[20%]'
              >
                <RunningProductItem
                  productIds={item.productIds}
                  thumbnail={item.thumbnail}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNavigation />
        </Carousel>
      </div>
    </CollectionContainer>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
